import React, { FormEvent, useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState<string | null>(null);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const apiUrl = import.meta.env.VITE_API_URL;

    try {
      const response = await fetch(`${apiUrl}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error(error);
      setStatus('error');
    }
  };

  return (
    <div className="py-12 min-h-screen flex items-center justify-center">
      <div className="max-w-2xl w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Kontakt</h1>
          <p className="text-lg text-gray-600 mb-8">
            Wir freuen uns auf Ihre Anfrage
          </p>
          <div className="flex items-center justify-center text-gray-600 mb-8">
            <svg className="w-5 h-5 mr-2 text-[#0055AA]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <span className="text-lg">info@beyondpages.io</span>
          </div>
        </div>

        <div className="bg-white p-8 rounded-lg shadow-lg">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-md border border-gray-300 shadow-sm focus:border-[#0055AA] focus:ring-[#0055AA] focus:ring-2 focus:ring-opacity-50 transition-colors"
                required
                placeholder="Ihr Name"
                data-testid="contact-name"
              />
            </div>
            
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                E-Mail
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-md border border-gray-300 shadow-sm focus:border-[#0055AA] focus:ring-[#0055AA] focus:ring-2 focus:ring-opacity-50 transition-colors"
                required
                placeholder="ihre.email@beispiel.de"
                data-testid="contact-email"
              />
            </div>
            
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                Nachricht
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={6}
                className="w-full px-4 py-3 rounded-md border border-gray-300 shadow-sm focus:border-[#0055AA] focus:ring-[#0055AA] focus:ring-2 focus:ring-opacity-50 transition-colors resize-none"
                required
                placeholder="Ihre Nachricht an uns..."
                data-testid="contact-message"
              ></textarea>
            </div>
            
            <button
              type="submit"
              className="w-full bg-[#FF9900] text-white px-6 py-4 rounded-lg font-semibold text-lg hover:bg-[#e68a00] transition-colors duration-200 shadow-md hover:shadow-lg"
              data-testid="contact-submit"
            >
              Nachricht senden
            </button>
          </form>
          
          {status === 'success' && (
            <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg" data-testid="contact-success">
              <div className="flex items-center">
                <svg className="w-5 h-5 text-green-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <p className="text-green-800 font-medium">E-Mail erfolgreich gesendet!</p>
              </div>
              <p className="text-green-700 text-sm mt-1">Wir melden uns schnellstmöglich bei Ihnen zurück.</p>
            </div>
          )}
          
          {status === 'error' && (
            <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-lg" data-testid="contact-error">
              <div className="flex items-center">
                <svg className="w-5 h-5 text-red-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
                <p className="text-red-800 font-medium">Fehler beim Senden der E-Mail.</p>
              </div>
              <p className="text-red-700 text-sm mt-1">Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Contact;
